// extracted by mini-css-extract-plugin
module.exports = {"stepper":"stepper_stepper__3nOKg","step":"stepper_step__3M-rp","icon":"stepper_icon__3W329","active":"stepper_active__396IE","label":"stepper_label__1nskp"};